import { render, staticRenderFns } from "./WanSettings.vue?vue&type=template&id=1579c716&"
import script from "./WanSettings.vue?vue&type=script&lang=js&"
export * from "./WanSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports